import React from "react";
import {FaHome, FaPhone, FaTimes, FaUser} from "react-icons/fa";

const AddEditCustomerModal = ({ show, handleClose, isEditing, formData, handleInputChange, handleSubmit, editingCustomerId }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                <div className="flex justify-between items-center border-b pb-2 mb-4">
                    <h2 className="text-xl font-semibold">
                        {isEditing ? "Edit Customer" : "Add Customer"}
                    </h2>
                    <button className="text-gray-500 hover:text-gray-700" onClick={handleClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="space-y-4">
                    {isEditing && (
                        <div>
                            <label className="block text-sm font-medium">ID</label>
                            <div className="flex items-center bg-gray-100 p-2 rounded-md">
                                <input
                                    type="text"
                                    name="id"
                                    value={editingCustomerId}
                                    readOnly
                                    className="bg-transparent focus:outline-none w-full"
                                />
                            </div>
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium">Name</label>
                        <div className="flex items-center bg-gray-100 p-2 rounded-md">
                            <FaUser className="text-gray-500 mr-2" />
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter customer name"
                                value={formData.name}
                                onChange={handleInputChange}
                                className="bg-transparent focus:outline-none w-full"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium">Contact</label>
                        <div className="flex items-center bg-gray-100 p-2 rounded-md">
                            <FaPhone className="text-gray-500 mr-2" />
                            <input
                                type="text"
                                name="phone"
                                placeholder="Enter contact number"
                                value={formData.phone}
                                onChange={handleInputChange}
                                className="bg-transparent focus:outline-none w-full"
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Address</label>
                        <div className="flex items-center bg-gray-100 p-2 rounded-md">
                            <FaHome className="text-gray-500 mr-2" />
                            <input
                                type="text"
                                name="address"
                                placeholder="Enter Address"
                                value={formData.address}
                                onChange={handleInputChange}
                                className="bg-transparent focus:outline-none w-full"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex justify-end space-x-2">
                        <button type="button" className="bg-gray-400 text-white px-4 py-2 rounded-md" onClick={handleClose}>
                            Cancel
                        </button>
                        <button onClick={handleSubmit} type="submit" className="bg-teal-400 text-white px-4 py-2 rounded-md">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEditCustomerModal;
